import { Box, Flex } from '@chakra-ui/react';

export const AvatarCircle = ({ children }: any) => {
	return (
		<Flex
			align="center"
			justify="center"
			pos="relative"
			borderRadius="50%"
			border="1.6px solid rgba(255, 255, 255, 0.3)"
			mr="8px"
			boxSize="44px"
		>
			<Box
				w="45px"
				h="22px"
				pos="absolute"
				bg="transparent"
				borderTopRadius="22px"
				borderWidth="2px 2px 0px"
				borderStyle="solid"
				borderRightColor="rgb(255, 63, 63)"
				borderColor="rgb(255, 63, 63)"
				top="11.5px"
				right="0"
				bottom="0"
				left="-20px"
				m="auto"
				transform="rotate(-120deg)"
			/>
			{children}
		</Flex>
	);
};
